export default "__VITE_ASSET__B5jm31v1__"